import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth';
import notifications from './notifications';
import users from './users';
import profile from './profile';
import testing from './testing';
import positions from './positions';
import profgrams from './profgrams';
import access from './access';
import analytics from './analytics';
import tests from './tests';
import testEditor from './testEditor';
import ai from './ai';
import services from './services';
import basket from './basket';
import news from './news';
import education from './education';
import diagnostics from './diagnostics';
import calendar from './calendar';
import publicCalendar from './publicCalendar';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    notifications,
    users,
    profile,
    testing,
    positions,
    profgrams,
    access,
    analytics,
    tests,
    testEditor,
    ai,
    services,
    basket,
    news,
    education,
    diagnostics,
    calendar,
    publicCalendar,
  },
});
